import type { IconData } from '@stacksjs/iconify-core'

export const birthdayCakeF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m20 15.693l-5.141 1.282l-4.82-.996l-4.935.996L0 15.687V15a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3zm0 2.063V22H0v-4.25l5.057 1.275l4.978-1.004l4.859 1.004zM7 9h6v2H7zm3-.6a3 3 0 0 1-3-3Q7 3.742 10 0q3 3.742 3 5.4a3 3 0 0 1-3 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default birthdayCakeF
